module.exports = __webpack_public_path__ + "static/media/io.4ea5b273.svg";